import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Button from "components/Forms/CustomButtons/ButtonTS";
import { useTranslation } from "react-i18next";

export interface GenericInformationModalProps {
  modalOpen: boolean;
  modalTitle: string;
  modalDescription: string;
  modalType: "confirm-action" | "sensitive-action";
  onAction: () => void;
  onClose?: () => void;
}

export function GenericInformationModal({
  modalOpen,
  modalTitle,
  modalDescription,
  modalType,
  onClose,
  onAction,
}: GenericInformationModalProps): JSX.Element {
  const { t } = useTranslation("modals");

  return (
    <Dialog
      open={modalOpen}
      fullWidth
      maxWidth="sm"
      scroll="body"
      onClose={() => {
        onClose();
      }}
      disableBackdropClick
    >
      <DialogTitle>
        {modalTitle}
        <Button
          justIcon
          simple
          color="tumblr"
          round
          size="sm"
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
          }}
          onClick={onClose}
        >
          <Close />
        </Button>
      </DialogTitle>

      <DialogContent>{modalDescription}</DialogContent>

      <DialogActions>
        <Button color="tumblr" simple onClick={onClose}>
          {t("cancel")}
        </Button>

        <Button
          color={modalType === "confirm-action" ? "success" : "danger"}
          onClick={onAction}
        >
          {t(modalType === "confirm-action" ? "conclude" : "proceed")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
